import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Hook to handle page loading and ensure content is properly initialized
export const usePageLoad = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Reset loaded state when route changes
    setIsLoaded(false);

    // Force a re-render to ensure content loads properly
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Additional effect to ensure content is visible after load
  useEffect(() => {
    if (isLoaded) {
      // Trigger a small delay to ensure all animations and content are ready
      const visibilityTimer = setTimeout(() => {
        // Force browser to recalculate layout
        window.dispatchEvent(new Event("resize"));
      }, 50);

      return () => clearTimeout(visibilityTimer);
    }

    // Return undefined for the else case to satisfy TypeScript
    return undefined;
  }, [isLoaded]);

  return { isLoaded };
};
